import { Operacao } from './operacao.model';
import { DadosUsuario } from './resposta-login-charon.model';
import { Link } from './session.model';

/**
 * Modelo de representação da sessão dos dados do usuário autenticado
 * @export
 * @class SessaoLogin
 */
export class SessaoLogin {
  constructor() {
    this.usuario = null;
    this.operacoes = new Array<Operacao>();
    this.sessionId = '';
    this.tokenJwt = null;
    this.links = null;
    this.siteKeyRecaptcha = ''
  }
  sessionId: string;
  usuario: DadosUsuario;
  operacoes: Array<Operacao>;
  tokenJwt: string;
  links: Link;
  charonTokenIssuedDate: Date;
  siteKeyRecaptcha: string;
}
